import { render, staticRenderFns } from "./DocIntro.vue?vue&type=template&id=c2170f7c&scoped=true&"
import script from "./DocIntro.vue?vue&type=script&lang=js&"
export * from "./DocIntro.vue?vue&type=script&lang=js&"
import style0 from "./DocIntro.vue?vue&type=style&index=0&id=c2170f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2170f7c",
  null
  
)

export default component.exports